module.exports = __webpack_public_path__ + "static/img/1.5820037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rcep_home/1.png
// module id = Ol0K
// module chunks = 2